import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'

export const TaxStructureMasterPopup = (props) => {
    return (
        <ModalBasic
            id="taxStructureMaster"
            classParams="!w-[55%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Tax group master</span>
                <div className='item-grp grid grid-cols-2 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Code</label>
                        <TextInput type='text'
                            id='code' name='code'
                            value={props.taxObject.code}
                            handleChange={(event) => props.handleChange(event, 'code')}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.taxObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp col-span-3'>
                        <label>Name</label>
                        <TextInput type='text'
                            id='name' name='name'
                            value={props.taxObject.name}
                            handleChange={(event) => props.handleChange(event, 'name')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>SGST (%)</label>
                        <TextInput type='number'
                            id='sgst' name='sgst'
                            value={props.taxObject.sgst}
                            handleChange={(event) => props.handleChange(event, 'sgst')}
                            className={props.validState?.error?.sgst !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>CGST (%)</label>
                        <TextInput type='number'
                            id='cgst' name='cgst'
                            value={props.taxObject.cgst}
                            handleChange={(event) => props.handleChange(event, 'cgst')}
                            className={props.validState?.error?.cgst !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>IGST (%)</label>
                        <TextInput type='number'
                            id='igst' name='igst'
                            value={props.taxObject.igst}
                            handleChange={(event) => props.handleChange(event, 'igst')}
                            className={props.validState?.error?.igst !== undefined ? "error" : ""}
                        />
                    </div>
                </div>
                <div className='item-grp grid grid-cols-3 gap-2.5 mt-3 mb-3'>
                    <div className='input-grp'>
                        <label>Input GST </label>
                        <MultiSelectDropdown
                            className={props.validState?.error?.idAccountHeadForInputGst !== undefined ? "error" : ""}
                            options={props.taxObject.accountheadListForInputGst}
                            //value={props.employeeBasicDetails.idAccountHead}
                            value={props.taxObject.idAccountHeadForInputGst ? props.taxObject.accountheadListForInputGst?.find(item => item.value === props.taxObject.idAccountHeadForInputGst) : 0}
                            //isDisabled={true}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(
                                    event,
                                    "idAccountHeadForInputGst"
                                )
                            }
                        />
                        {/* <TextInput type='number'
                            id='sgst' name='sgst'
                            value={props.taxObject.sgst}
                            handleChange={(event) => props.handleChange(event, 'sgst')}
                            className={props.validState?.error?.sgst !== undefined ? "error" : ""}
                        /> */}
                    </div>
                    <div className='input-grp'>
                        <label>Output GST</label>
                        <MultiSelectDropdown
                            className={props.validState?.error?.idAccountHead !== undefined ? "error" : ""}
                            options={props.taxObject.accountheadListForOutputGst}
                            //value={props.employeeBasicDetails.idAccountHeadForOutputGst}
                            value={props.taxObject.idAccountHeadForOutputGst ? props.taxObject.accountheadListForOutputGst?.find(item => item.value === props.taxObject.idAccountHeadForOutputGst) : 0}
                            //isDisabled={true}
                            onChange={(event) =>
                                props.handleChangeFroDropdown(
                                    event,
                                    "idAccountHeadForOutputGst"
                                )
                            }
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}